import { Layer } from './styles';

export const Overlay = ({ children }) => <Layer>{children}</Layer>;
